var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.482,50.916c-8.099-4.226-18.091-1.088-22.321,7.013l-41.925,80.336l-46.147,36.662c-6.335,0-46.901,0-54.683,0 l-57.033-18.756l-33.145-53.595l5.854-5.694c3.554-3.457,3.634-9.143,0.176-12.697l-13.735-14.12l10.294-10.014 c4.024-3.914,4.113-10.35,0.198-14.374l-41.438-42.6c-3.914-4.024-10.35-4.113-14.374-0.198L65.703,67.566 c-4.024,3.914-4.113,10.35-0.198,14.374l41.438,42.599c3.914,4.024,10.35,4.113,14.374,0.198l10.294-10.013l13.737,14.121 c3.449,3.547,9.136,3.64,12.696,0.176l2.896-2.817l32.466,52.499c2.049,3.313,5.201,5.797,8.901,7.014l58.436,19.218 l0.008,287.213c0,10.964,8.888,19.853,19.852,19.853c10.964,0,19.852-8.888,19.852-19.853V333.466l8.565-2.239l24.462,64.136 l-17.398,78.459c-2.373,10.704,4.38,21.306,15.084,23.679c10.69,2.373,21.303-4.371,23.679-15.083l18.771-84.647 c0.892-4.025,0.509-8.227-1.096-12.026l-24.153-57.154V202.66l51.197-40.674c1.812-1.441,3.304-3.245,4.375-5.299l43.551-83.45 C451.722,65.137,448.581,55.143,440.482,50.916z M171.921,90.467c-4.083-0.926-8.515-0.318-12.357,2.058 c-6.031,3.73-8.81,10.704-7.514,17.272l-0.092,0.088l-7.475-7.683l20.167-19.617l7.475,7.684L171.921,90.467z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 304.734,
    cy: 129.707,
    r: 34.286
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.6fbd2a1ea7c45790a9eb1af312c8b19f.svg";
export { ForwardRef as ReactComponent };